export const Role = {
  Admin: 1,
  Manager: 2,
}
